import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const DataTableContainer = styled(Box)`
  height: 300px;
  margin-top: ${({ theme }) => theme.spacing(2)};

  & > div {
    height: 100%;
  }

  .fullscreen & {
    height: auto;
    flex: 1;
    min-height: 0;
  }
`;
